module.exports = __webpack_public_path__ + "img/psm_logo-inverse.0b926897.png";